import { getView, requireAuth } from '@/lib/utils';
import { AssetsPage } from '@/data/appInformationItems';
import { Left } from 'Models/Menu/menus';

export default {
  path: '/dosing',
  component: getView('pages/PageDosing'),
  name: 'dosing',
  beforeEnter: requireAuth,
  meta: {
    crumbs: 'Dosing',
    leftMenu: Left.AnalyticsPage,
    roles: ['operator'],
    information: AssetsPage,
    showBottomMenu: true,
    isFlowChem: false,
    crumbsIcon: 'flow-dosing',
  },
};
